
import {BaseMuWidget} from "./BaseMuWidget";
import {CalCL} from "./generated/CalCL";
import {AnyElement, MuNamedWidgets} from "mu-widget/lib/MuWidget";
import {CalendarOverview, CalendarOverviewItem} from "./components/CalendarOverview";
import {CalendarItem} from "./CommonTypes";
import {UiCalendarItemDetail} from "./UiCalendarItemDetail";
import {TodoTicketForm} from "./TodoTicketForm";
import {YMPeriod, YMPeriodMonth} from "./Utils";
import {BaseRouter} from "./BaseRouter";
import {Ticket} from "./TicketTypes";
import {DateRepeating} from "./components/DateRepeating";
import {UiTabs} from "mu-widget/lib/UiTabs";

export class CalendarPage extends BaseMuWidget
{
    public cl = new CalCL();

    // @ts-ignore
    muNamedWidget: MuNamedWidgets<{
        calendar: CalendarOverview,
        tabs:UiTabs,
    }>

    beforeIndex() {
        this.muAppendContent(`
        <h3 class="display-flex-row align-items-center">
            <span class="icon-before-left icon-before--autosize a-nc" mu="bPeriodPrev"></span>
            <input type="month" class="calendar-page__period h3" mu="period" />
            <span class="icon-before-right icon-before--autosize a-nc" mu="bPeriodNext"></span>
            <span class="flex-grow-1"></span>
            <!-- <span class="icon-before-search icon-before--autosize a-nc" mu="bSearch">Hledání</span>        
            <span class="icon-before-calendar icon-before--autosize a-nc" mu="bCalendar">Kalendář</span> -->
            <div mu="tabs:UiTabs" class="font-size-normal"></div>        
        </h3>
        <div mu="calendar:CalendarOverview" tab-label="Kalendář">
			<div mu=":UiCalendarItem@item">
				<span mu="#note"></span>
			</div>
        </div>
        <div mu="cSearch" tab-label="Hledání">
            <div mu-keybind="Enter:bDoSearch">
                <div class="row form-group">
                    <label class="col-2 control-label" mu-for="fulltext">Hledaný text</label>
                    <div class="col-10">
                        <input type="search" mu="fulltext" class="form-control" />
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-2 control-label" mu-for="dtFrom">Datum od</label>
                    <div class="col-4">
                        <input type="date" mu="dtFrom" class="form-control" />
                    </div>
                    <label class="col-2 control-label" mu-for="dtTo">do</label>
                    <div class="col-4">
                        <input type="date" mu="dtTo" class="form-control" />
                    </div>
                </div>
                <div class="buttons">
                    <span class="btn btn-primary icon-before-search" mu="bDoSearch">Vyhledat</span>    
                </div>
            </div>

            <div class="alert alert-warning" mu="manyResultsAlert" style="display: none">
                Nalezeno příliž mnoho výsledků, upřesněte hledaný termín.    
            </div>
            <table mu="searchResultsContainer" class="table">
                <tbody mu="searchResults#searchResults:@foreach">
                    <tr mu=":UiCalendarRow@searchResultItem" class="a-nc">
                    </tr>
                </tbody>
            </table>        
        </div>
        `);
        this.container.classList.add("calendar-page", "calendar-page--month")
    }

    async afterIndex() {
        this.ui.period.value = new Date().toISOString().substring(0, 7);
    }

    protected async doInit(): Promise<void> {
        this.period_change();
    }

    protected currentY :number = -1;
    protected currentM :YMPeriodMonth = 0;
    async reloadCalendar(y: number|null = null, m: YMPeriodMonth|null = null) {
        if (y !== null) this.ui.period.value = YMPeriod.toInput(y, m);
        this.currentM = m ?? this.currentM;
        this.currentY = y ?? this.currentY;
        const data = await this.cl.withMessage('Načítám kalendář', this.ui.calendar)
            .getCalOverview( YMPeriod.toNum(this.currentY, this.currentM));
        this.muNamedWidget.calendar.bindData(this.currentY, this.currentM, data.items);
    }

    bDoSearch_click() {
        this.loadSearchResults();
    }

    async loadSearchResults() {
        const data = await this.cl.withMessage('Hledám v kalendáři', this.ui.searchResultsContainer)
            .searchInCalendar(
                this.ui.dtFrom.value,
                this.ui.dtTo.value,
                this.ui.fulltext.value,
            );
        this.muVisible(data.manyResults, 'manyResultsAlert');
        this.muBindData({
            searchResults: data.items
        });
    }

    bPeriodPrev_click() {
        this.shiftPeriod(-1);
    }
    bPeriodNext_click() {
        this.shiftPeriod(1);
    }

    period_change() {
        const p = YMPeriod.inputToYM(this.ui.period.value);
        if (p) this.reloadCalendar(...p);
    }

    openItem(item: CalendarItem) {
        if (item.ticket?.projectCode === "TODO") {
            this.openTodoEditor(null, item.ticket.id, "ticket");
        } else if (item.calItemRepeating) {
            this.openTodoEditor(null, item.calItemRepeating.id, "cir");
        } else {
            this.openInModal<UiCalendarItemDetail>('UiCalendarItemDetail', "Detail položky kalendáře")
                .bindData(item);
        }

    }

    calendar_add(ev: any, dt: Date|null) {
        this.openTodoEditor(dt);
    }
    openTodoEditor(dt: Date|null, id: number|null = null, itemType: "ticket"|"cir"|null = null) {
        const ttf = this.openInModal(
            'TodoTicketForm',
            " ",
            { muParent: this }
        ) as TodoTicketForm;
        if (dt) {
            ttf.muBindData({
                dtTerm: dt,
                repeating: {
                    dtFrom: dt,
                    dayOfMonth: dt.getDate(),
                    dayOfWeek: (dt.getDay() + 6) % 7,
                }
            });
        }
        if (itemType) {
            ttf.doLoad(id!, itemType);
        } else {
            ttf.doNew();
        }
        ttf.addEventListener('saved', () => {
            ttf.muRemoveSelf();
            this.reloadCalendar();
        });

        return ttf;
    }

    private shiftPeriod(change: number) {
        this.ui.period.value = YMPeriod.shift(this.ui.period.value, change);
        this.period_change();
    }

    setMonth(dt: string) {
        this.ui.period.value = dt.substring(0, 7);
        this.period_change();
        this.muNamedWidget.tabs.selectTab('calendar');
    }
}

export class UiCalendarItem extends CalendarOverviewItem {
    public item: any = null;

    afterIndex() {
    }

    protected muAfterBindData(data: CalendarItem) {
        const ccl = [];
        if (data.ticket) {
            ccl.push('calendar-item--state-' + data.ticket.stateCode);
        }
        this.container.classList.add(...ccl);
    }

    container_click() {
        (this.muParent.muParent as unknown as CalendarPage).openItem(this.item);
    }
}

export class UiCalendarRow extends BaseMuWidget {
    public item: any = null;

    beforeIndex() {
        this.muAppendContent(`
            <td><span mu="stateIcon"></span></td>
            <td>
                <span class="icon-before-calendar" title="Otevřít měsíc v kalendáři" mu-click='openMonth:"dtFrom"'></span>
                <span mu="dtFrom#dtFrom|date"></span>
            </td>
            <td>
                <span class="icon-before-calendar" title="Otevřít měsíc v kalendáři" mu-click='openMonth:"dtFrom"' mu-bind="dtTo:@visible"></span>
                <span mu-bind="dtTo|date"></span>
            </td>
            <td><span mu="icon"></span></td>
            <td><span mu="note#note"></span> <em class="content-in-brackets" mu="noteAddon"></em></td>
        `);
    }

    openMonth(ev: Event, field: string) {
        this.callMethodInFirstAncestors('setMonth', this.item[field]);
        ev.stopPropagation();
    }

    afterIndex() {
    }

    protected muAfterBindData(data: CalendarItem) {
        const ccl = [];
        if (data.ticket) {
            ccl.push('calendar-item--state-' + data.ticket.stateCode);
        }
        this.ui.stateIcon.classList.add(...ccl);
        this.item = data;
        this.ui.icon.classList.add('icon-before-' + {
            calItem: "calendar",
            calItemRepeating: "calendar-range",
            procDataValue: "pqm-item",
        }[data.type]);
        this.ui.icon.title = {
            calItem: "Položka kalendáře",
            calItemRepeating: "Opakovaná položka",
            procDataValue: "Datum z procesu",
        }[data.type];

        if (data.calItemRepeating) {
            this.ui.noteAddon.innerText = DateRepeating.getTextInfo(data.calItemRepeating);
        }
    }

    container_click() {
        (this.muParent as unknown as CalendarPage).openItem(this.item);
    }
}

export class CalendarPageRouter extends BaseRouter {
    paTicket(a: AnyElement, ticket: Ticket) {
        super.paTicket(a, ticket);
    }
}